module.exports = __webpack_public_path__ + "img/printer_small.b02db83e.png";